<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header card-gis-filter">
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="1">
            <div class="row p-3">
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                <label>{{ $t('common_words.farm') }} *</label>
                <br />
                <el-select
                  id="farm_irrigation_compliance"
                  clearable
                  multiple
                  @change="
                    selectAllFromSelect('complianceForm.farm_id', farms);
                    handleChange();
                  "
                  v-bind:collapse-tags="true"
                  filterable
                  class="select-primary custom-width-select required-farm shadow-sm"
                  size="large"
                  v-model="complianceForm.farm_id"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="(option, index) in farms"
                    class="select-primary selected-all"
                    :value="option.id"
                    :label="option.name"
                    :key="index + option.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                <label>{{ $t('common_words.type') }} *</label>
                <br />
                <el-select
                  id="farm_irrigation_compliance"
                  clearable
                  @change="handleChange"
                  v-bind:collapse-tags="true"
                  filterable
                  class="select-primary custom-width-select required-farm shadow-sm"
                  size="large"
                  v-model="complianceForm.typeReport"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="(option, index) in options"
                    class="select-primary"
                    :value="option.id"
                    :label="option.name"
                    :key="index + option.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                <label>{{ $t('common_words.date') }} *</label>
                <br />
                <el-date-picker
                  v-if="renderComponent"
                  @change="handleChange"
                  id="date_irrigation_compliance"
                  class="shadow-sm required-date"
                  v-model="complianceForm.rangeDate"
                  type="daterange"
                  :picker-options="pickerOptions"
                  :placeholder="`${$t('common_words.select2')}...`"
                >
                </el-date-picker>
              </div>
              <div class="col-12 col-md-4 col-xl-2">
                <label class="label-primary" style="color: transparent">{{
                  $t('common_words.filter')
                }}</label
                ><br />
                <l-button wide type="info" class="btn-filter" @click="validate">
                  {{ $t('common_words.generate') }}
                </l-button>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </card>
      <br />
      <card
        class="custom-shadow-card-header custom-table-responsive"
        v-if="irrigationCompliance"
        :title="$t('irrigation.irrigation_compliance_report')"
      >
        <div class="mt-4">
          <div class="row" v-if="isIndex()">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                clearable
                @clear="pagination.perPage = 10"
                class="select-default mb-3 shadow-sm"
                style="width: 200px"
                v-model="pagination.perPage"
                :placeholder="$t('common_words.per_page')"
                filterable
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
              <el-input
                clearable
                class="mb-3 shadow-sm"
                style="width: 200px"
                :placeholder="$t('common_words.search_records')"
                v-model="searchQuery"
                aria-controls="datatables"
              />
              <div class="col-sm-12">
                <div class="table-responsive">
                  <table
                    class="table table-striped table-bordered"
                    v-if="irrigationCompliance"
                  >
                    <thead class="cusmtom-thead-color">
                      <tr>
                        <td
                          v-if="complianceForm.typeReport === 1"
                          class="text-center p-3"
                          style="
                            font-weight: bolder;
                            font-size: 14px;
                            min-width: 150px;
                          "
                        >
                          {{ $t('common_words.date') }}
                        </td>
                        <td
                          v-if="complianceForm.typeReport === 2"
                          class="text-center p-3"
                          style="
                            font-weight: bolder;
                            font-size: 14px;
                            min-width: 150px;
                          "
                        >
                          {{ $t('common_words.total_day') }}
                        </td>
                        <td
                          class="text-center p-3"
                          style="
                            font-weight: bolder;
                            font-size: 14px;
                            min-width: 150px;
                          "
                        >
                          {{ $t('common_words.farm') }}
                        </td>
                        <td
                          v-if="complianceForm.typeReport === 1"
                          class="text-center p-3"
                          style="
                            font-weight: bolder;
                            font-size: 14px;
                            min-width: 150px;
                          "
                        >
                          {{ $t('irrigation.engine') }}
                        </td>
                        <td
                          class="text-center p-3"
                          style="
                            font-weight: bolder;
                            font-size: 14px;
                            min-width: 150px;
                          "
                        >
                          {{ $t('irrigation.plate_apply_unit') }}
                        </td>
                        <td
                          class="text-center p-3"
                          style="
                            font-weight: bolder;
                            font-size: 14px;
                            min-width: 150px;
                          "
                        >
                          {{ $t('irrigation.plate_applied_unit') }}
                        </td>
                        <td
                          class="text-center p-3"
                          style="
                            font-weight: bolder;
                            font-size: 14px;
                            min-width: 150px;
                          "
                        >
                          {{ $t('irrigation.plate_compliance_percentage') }}
                        </td>
                        <td
                          class="text-center p-3"
                          style="
                            font-weight: bolder;
                            font-size: 14px;
                            min-width: 150px;
                          "
                        >
                          {{
                            $t('irrigation.irrigation_total_apply_time_unit')
                          }}
                        </td>
                        <td
                          class="text-center p-3"
                          style="
                            font-weight: bolder;
                            font-size: 14px;
                            min-width: 150px;
                          "
                        >
                          {{ $t('irrigation.total_applied_time_unit') }}
                        </td>
                        <td
                          class="text-center p-3"
                          style="
                            font-weight: bolder;
                            font-size: 14px;
                            min-width: 150px;
                          "
                        >
                          {{ $t('irrigation.time_compliance_percentage') }}
                        </td>
                        <td
                          class="text-center p-3"
                          style="
                            font-weight: bolder;
                            font-size: 14px;
                            min-width: 150px;
                          "
                        >
                          {{ $t('irrigation.volume_total_apply') }}
                        </td>
                        <td
                          class="text-center p-3"
                          style="
                            font-weight: bolder;
                            font-size: 14px;
                            min-width: 150px;
                          "
                        >
                          {{ $t('irrigation.volume_total_applied') }}
                        </td>
                        <td
                          class="text-center p-3"
                          style="
                            font-weight: bolder;
                            font-size: 14px;
                            min-width: 150px;
                          "
                        >
                          {{ $t('irrigation.volume_compliance_percentage') }}
                        </td>
                        <td
                          class="text-center p-3"
                          style="
                            font-weight: bolder;
                            font-size: 14px;
                            min-width: 150px;
                          "
                        >
                          {{ $t('climate.rain_unit') }}
                        </td>
                        <td
                          class="text-center p-3"
                          style="
                            font-weight: bolder;
                            font-size: 14px;
                            min-width: 150px;
                          "
                        >
                          {{ $t('common_words.observation') }}
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(data, i) in queriedData" :key="i">
                        <td
                          class="text-center"
                          v-if="complianceForm.typeReport === 1"
                        >
                          {{ data.date_save }}
                        </td>
                        <td
                          class="text-center"
                          v-if="complianceForm.typeReport === 2"
                        >
                          {{ data.date_count }}
                        </td>
                        <td class="text-center">{{ data.name }}</td>
                        <td
                          class="text-center"
                          v-if="complianceForm.typeReport === 1"
                        >
                          {{ data.engine }}
                        </td>
                        <td class="text-center">
                          {{
                            new Intl.NumberFormat('en-EN').format(
                              data.lamina_a_aplicar
                            )
                          }}
                        </td>
                        <td class="text-center">
                          {{
                            new Intl.NumberFormat('en-EN').format(
                              data.lamina_aplicada
                            )
                          }}
                        </td>
                        <td class="text-center">
                          {{
                            new Intl.NumberFormat('en-EN').format(
                              data.cumplimiento_lamina
                            )
                          }}
                        </td>
                        <td class="text-center">
                          {{
                            new Intl.NumberFormat('en-EN').format(
                              data.tiempo_regar
                            )
                          }}
                        </td>
                        <td class="text-center">
                          {{
                            new Intl.NumberFormat('en-EN').format(
                              data.hourmeter
                            )
                          }}
                        </td>
                        <td class="text-center">
                          {{
                            new Intl.NumberFormat('en-EN').format(
                              data.cumplimiento_tiempo
                            )
                          }}
                        </td>
                        <td class="text-center">
                          {{
                            new Intl.NumberFormat('en-EN').format(
                              data.volumen_regar
                            )
                          }}
                        </td>
                        <td class="text-center">
                          {{
                            new Intl.NumberFormat('en-EN').format(
                              data.hydrometer
                            )
                          }}
                        </td>
                        <td class="text-center">
                          {{
                            new Intl.NumberFormat('en-EN').format(
                              data.cumplimiento_riego
                            )
                          }}
                        </td>
                        <td class="text-center">
                          {{
                            new Intl.NumberFormat('en-EN').format(
                              data.precipitacion
                            )
                          }}
                        </td>
                        <td
                          class="text-center"
                          v-if="complianceForm.typeReport === 1"
                          colspan="3"
                        >
                          {{ data.observation }}
                        </td>
                        <td
                          class="text-center"
                          v-if="complianceForm.typeReport === 2"
                          colspan="3"
                        >
                          <template v-for="(obs, index) in data.observation">
                            <span v-if="obs.id" :key="index"
                              >{{ `${obs.count} ${obs.description}` }}
                              <br />
                            </span>
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="text-center"
                          v-if="complianceForm.typeReport === 1"
                          colspan="3"
                        >
                          <b>{{ $t('common_words.total_mayus') }}</b>
                        </td>
                        <td
                          class="text-center"
                          v-if="complianceForm.typeReport === 2"
                          colspan="2"
                        >
                          <b>{{ $t('common_words.total_mayus') }}</b>
                        </td>
                        <td class="text-center">
                          <b>{{
                            Math.round(
                              (totales.total_lamina + Number.EPSILON) * 100
                            ) / 100
                          }}</b>
                        </td>
                        <td class="text-center">
                          <b>{{
                            new Intl.NumberFormat('en-EN').format(
                              totales.total_lamina_aplicada
                            )
                          }}</b>
                        </td>
                        <td class="text-center">
                          <b>{{
                            new Intl.NumberFormat('en-EN').format(
                              totales.total_cumplimiento_lamina
                            )
                          }}</b>
                        </td>
                        <td class="text-center">
                          <b>{{
                            new Intl.NumberFormat('en-EN').format(
                              totales.total_tiempo_total_aplicar
                            )
                          }}</b>
                        </td>
                        <td class="text-center">
                          <b>{{
                            new Intl.NumberFormat('en-EN').format(
                              totales.total_tiempo_aplicado
                            )
                          }}</b>
                        </td>
                        <td class="text-center">
                          <b>{{
                            new Intl.NumberFormat('en-EN').format(
                              totales.total_cumplimiento_tiempo
                            )
                          }}</b>
                        </td>
                        <td class="text-center">
                          <b>{{
                            new Intl.NumberFormat('en-EN').format(
                              totales.total_volumen_aplicar
                            )
                          }}</b>
                        </td>
                        <td class="text-center">
                          <b>{{
                            new Intl.NumberFormat('en-EN').format(
                              totales.total_volumen_aplicado
                            )
                          }}</b>
                        </td>
                        <td class="text-center">
                          <b>{{
                            new Intl.NumberFormat('en-EN').format(
                              totales.total_cumplimiento_volumen
                            )
                          }}</b>
                        </td>
                        <td class="text-center">
                          <b>{{
                            new Intl.NumberFormat('en-EN').format(
                              totales.total_lluvia
                            )
                          }}</b>
                        </td>
                        <td
                          class="text-center"
                          v-if="totales.totales_observacion.length > 0"
                        >
                          <template
                            v-for="(obs, index) in totales.totales_observacion"
                          >
                            <span v-if="obs.id" :key="index">
                              {{ `${obs.count} ${obs.description}` }}
                              <br />
                            </span>
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">
                {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
                {{ to }} {{ $t('table2.of') }} {{ total }}
                {{ $t('table2.entries') }}
              </p>
            </div>
            <l-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              pageFirst="false"
              pageLast="false"
            ></l-pagination>
          </div>
        </div>
        <div class="row" style="padding-right: 13px; padding-left: 13px">
          <div class="col-6" v-if="isPDF()">
            <div class="text-right">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="exportPDF"
              >
                <em class="fa fa-file-pdf-o"></em>
                {{ $t('common_words.export_to_pdf') }}
              </button>
            </div>
          </div>
          <div class="col-6" v-if="isExcel()">
            <div class="text-left">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="exportExcel"
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_excel') }}
              </button>
            </div>
          </div>
        </div>
      </card>
      <card class="custom-shadow-card-header" v-if="irrigationCompliance">
        <div class="row">
          <div class="col-12">
            <highcharts :options="chartOptionsLamina"></highcharts>
          </div>
        </div>
      </card>
      <card class="custom-shadow-card-header" v-if="irrigationCompliance">
        <div class="row">
          <div class="col-12">
            <highcharts :options="chartOptionsTiempo"></highcharts>
          </div>
        </div>
      </card>
      <card class="custom-shadow-card-header" v-if="irrigationCompliance">
        <div class="row">
          <div class="col-12">
            <highcharts :options="chartOptionsVolumen"></highcharts>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import Fuse from 'fuse.js';
import moment from 'moment';
import store from '@/store';
import { mapActions } from 'vuex';
import { Chart } from 'highcharts-vue';
import SweetAlert from 'src/class/Alerts';
import configTable from './paginationData';
import mixinMasters from 'src/util/mixinMasters';
import MixinDatePicker from 'src/util/mixinDatePicker';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinDinamicCharts from 'src/util/mixinDinamicCharts';
import { MixinExport } from 'src/mixins/mixin-export';
import { Pagination as LPagination } from 'src/components/index';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import i18n from 'src/i18n';

export default {
  components: {
    LPagination,
    highcharts: Chart,
  },

  computed: {
    ...configTable().Search,
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    options() {
      return [
        { id: 1, name: i18n.t('common_words.detailed') },
        { id: 2, name: i18n.t('common_words.consolidated') },
      ];
    },
  },

  data() {
    return {
      farms: [],
      complianceForm: {
        farm_id: [],
        rangeDate: null,
        typeReport: null,
      },
      activeName: '1',
      tableData: [],
      totales: [],
      valueCollapse: null,
      chartData: [],
      pagination: {},
      tableColumns: [],
      searchQuery: '',
      fuseSearch: null,
      irrigationCompliance: false,
      chartOptionsVolumen: {},
      chartOptionsTiempo: {},
      chartOptionsLamina: {},
      flag: null,
      getFarmEngine: null,
      getAxis: null,
      getSeriesVolume: null,
      getMinHeight: null,
      getSeriesTime: null,
      getSeriesPlate: null,
    };
  },

  mixins: [
    MixinPermissions,
    mixinMasters,
    MixinDinamicCharts,
    MixinDatePicker,
    MixinExport,
    MixinMenu,
  ],

  watch: {
    '$i18n.locale': ['setupTable', 'getSelectAll', 'forceRerender'],
  },

  methods: {
    getSelectAll() {
      this.farms = this.concatAll(this.farms.splice(1));
    },

    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    handleChange() {
      this.tableData = [];
      this.totales = [];
      this.chartData = [];
      this.irrigationCompliance = false;
    },

    validate() {
      return this.$validator.validateAll().then((response) => {
        if (!this.complianceForm.farm_id) {
          let sel = document.getElementById('farm_irrigation_compliance');
          sel.focus();
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
          return false;
        }

        if (!this.complianceForm.rangeDate) {
          let sel = document.getElementById('date_irrigation_compliance');
          sel.focus();
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
          return false;
        }

        this.loadCompliance();
      });
    },

    setSeriesVolume() {
      if (this.flag) {
        this.chartOptionsVolumen = this.barChart(
          i18n.t('irrigation.volume_to_apply_applied'),
          this.getFarmEngine,
          this.getAxis,
          this.getSeriesVolume,
          i18n.t('irrigation.volume'),
          this.getMinHeight,
          this.flag
        );
      }
    },
    setSeriesTime() {
      if (this.flag) {
        this.chartOptionsTiempo = this.barChart(
          i18n.t('irrigation.time_to_apply_applied'),
          this.getFarmEngine,
          this.getAxis,
          this.getSeriesTime,
          i18n.t('common_words.time'),
          this.getMinHeight,
          this.flag
        );
      }
    },
    setSeriesPlate() {
      if (this.flag) {
        this.chartOptionsLamina = this.barChart(
          i18n.t('irrigation.plate_to_apply_applied'),
          this.getFarmEngine,
          this.getAxis,
          this.getSeriesPlate,
          i18n.t('irrigation.plate_normal'),
          this.getMinHeight,
          this.flag
        );
      }
    },

    loadCompliance() {
      this.showHideLoading(true);

      this.pagination.perPage = 10;
      this.pagination.currentPage = 1;
      this.searchQuery = '';

      this.complianceForm.rangeDate[0] = new moment(
        this.complianceForm.rangeDate[0]
      ).format('YYYY-MM-DD');
      this.complianceForm.rangeDate[1] = new moment(
        this.complianceForm.rangeDate[1]
      ).format('YYYY-MM-DD');
      this.complianceForm.route = 'irrigation/compliance';
      Axios.postMasters(this.complianceForm)
        .then((response) => {
          this.showHideLoading();
          // let minHeight = this.complianceForm.typeReport === 1 ? 10000 : 700;
          this.flag = response.data;
          this.tableData = response.data.data.tableData.tableData;
          this.chartData = response.data.data.chartData;
          this.totales = response.data.data.tableData.totales;

          let minHeight;
          if (this.complianceForm.typeReport === 1) {
            minHeight = this.chartData.xAxis.length * 15 * 3;
          } else if (this.complianceForm.typeReport === 2) {
            minHeight = this.chartData.xAxis.length * 15;
          }

          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((prop) => {
              return prop.prop;
            }),
          });
          this.getAxis = this.chartData.xAxis;
          this.getFarmEngine = this.chartData.farmOrEngine;
          this.getSeriesVolume = this.chartData.seriesVolumen;
          this.getMinHeight = minHeight;
          this.getSeriesTime = this.chartData.seriesTiempo;
          this.getSeriesPlate = this.chartData.seriesLamina;
          try {
            this.setSeriesVolume();
          } catch (error) {
            console.log('error: ', error);
          }

          try {
            this.setSeriesTime();
          } catch (error) {
            console.log('error: ', error);
          }

          try {
            this.setSeriesPlate();
          } catch (error) {
            console.log('error: ', error);
          }
          this.irrigationCompliance = true;
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportPDF() {
      let data = {
        route: 'irrigation/compliance/pdf',
        tableData: this.tableData,
        totales: this.totales,
        typeReport: this.complianceForm.typeReport,
        name_file: 'cumplimientoRiego.pdf',
      };

      this.PDF(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportExcel() {
      let data = {
        route: 'irrigation/compliance/excel',
        tableData: this.tableData,
        totales: this.totales,
        typeReport: this.complianceForm.typeReport,
        name_file: 'cumplimientoRiego.xlsx',
      };

      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    this.setupTable();
    Axios.getMasters('farms/farms/only')
      .then((response) => {
        this.farms = this.concatAll(response.data.data);
      })
      .catch((error) => {
        console.log('ERROR');
      });

    let current = new Date();
    this.complianceForm.rangeDate = [
      new Date(current.setDate(current.getDate() - current.getDay())),
      new Date(current.setDate(current.getDate() - current.getDay() + 6)),
    ];
  },

  mounted() {
    this.selectedItemOnMenu('irrigation');
  },

  destroyed() {
    this.deselectedItemOnMenu('irrigation');
  },
};
</script>

<style scoped></style>
